import {styled} from "@reside/ui";

export const SuccessMessage = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: center;
  margin-bottom: 32px;
`;
